export const emptyStringToNull = (value: string, originalValue: string) => {
  return originalValue === "" ? null : value;
};
